const NOT_DIGITS = /[^0-9]/g;
const remove =
  (regEx) =>
  (someString = "") =>
    someString.replace(regEx, "");
export const removeNonDigits = remove(NOT_DIGITS);

const GUID =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
export const checkAccountNumber = (str) => GUID.test(str);
